import { render, staticRenderFns } from "./CommunicationsCenter.vue?vue&type=template&id=4b414c77&scoped=true&lang=pug&"
import script from "./CommunicationsCenter.vue?vue&type=script&lang=js&"
export * from "./CommunicationsCenter.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationsCenter.vue?vue&type=style&index=0&id=4b414c77&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b414c77",
  null
  
)

export default component.exports